<template src="./CallbackZaloComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import {AppConstant} from "@/supports/app.constant.ts";
import {useStore} from "@/stores/store.js";
import {useSyncZalo} from "@/stores/syncZalo.js";
import {useAccountStore} from "@/stores/account.js";
import ProgressBarNormal from "@/components/progress-bar/normal/ProgressBarNormal.vue";
import InputPasswordNormal from "@/components/inputs/input-password/normal/InputPasswordNormal.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import ButtonNextComponent from "@/components/buttons/button-next/ButtonNextComponent.vue";
import {useRoute} from "vue-router";
import ErrorMessageService from "@/services/error-message.service.ts";
export default {
  name: 'CallbackZaloComponent',
  computed: {
    AppConstant() {
      return AppConstant
    }
  },
  components: {
    ButtonNextComponent, ButtonAddComponent, ButtonBackComponent, InputDateTimeNormal, InputPasswordNormal,
    ProgressBarNormal,
    ButtonSearchComponent,
    SelectNormal,
    InputTextNormal,
    BreadcrumbComponent,
    IconHome
  },
  setup() {
    const errors = ref(false);
    const errorMessage = ref([])
    const accountStore = useAccountStore()
    const syncZaloStore = useSyncZalo()
    const code = ref('')
    const code_challenge = ref('')
    const oa_id = ref('')
    const companyCode = ref('')
    const showButtonConnect = ref(false)
    const route = useRoute()
    onMounted(() => {
      companyCode.value = route.params.companyCode;
      oa_id.value = route.query.oa_id;
      code.value = route.query.code;
      code_challenge.value = route.query.code_challenge;
      validateUrlCallback()
      checkURLCallback()
    });

    function validateUrlCallback() {
      if(accountStore.account.company.companycode !== companyCode.value) {
        errors.value = true
        errorMessage.value.push('URL callback đang không hợp lệ. Vui lòng kiểm tra lại!')
      }
      if(!errors.value && !oa_id.value) {
        errors.value = true
        errorMessage.value.push('URL callback đang không hợp lệ: Param oa_id đang không có gí trị. Vui lòng kiểm tra lại!')
      }
      if(!errors.value && !code.value) {
        errors.value = true
        errorMessage.value.push('URL callback đang không hợp lệ: Param code đang không có gí trị. Vui lòng kiểm tra lại!')
      }
      if(!errors.value && !code_challenge.value) {
        errors.value = true
        errorMessage.value.push('URL callback đang không hợp lệ: Param code_challenge đang không có gí trị. Vui lòng kiểm tra lại!')
      }
    }
    async function connectZalo() {
      if(!errors.value) {
        const params = {
          company_id: accountStore.account.company.id,
          oa_id: oa_id.value,
          authorization_code: code.value,
          code_challenge: code_challenge.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/callback-zalo';
        const res = await syncZaloStore.callbackZalo(url, params);
        const prepareErrorMessageApi = await ErrorMessageService.getErrorMessage(res)
        if(prepareErrorMessageApi === undefined) {

        }else {
          errorMessage.value = typeof prepareErrorMessageApi === 'string' ? [prepareErrorMessageApi] : prepareErrorMessageApi
        }
      }
    }

    async function checkURLCallback() {
      if(!errors.value) {
        showButtonConnect.value = true
        const params = {
          company_id: accountStore.account.company.id,
          oa_id: oa_id.value,
          authorization_code: code.value,
          code_challenge: code_challenge.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-zalo/check-callback-zalo';
        const res = await syncZaloStore.checkURLCallback(url, params);
        const prepareErrorMessageApi = await ErrorMessageService.getErrorMessage(res)
        if(prepareErrorMessageApi !== undefined) {
          showButtonConnect.value = false
          errorMessage.value = typeof prepareErrorMessageApi === 'string' ? [prepareErrorMessageApi] : prepareErrorMessageApi        }else {
        }
      }
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    return {
      connectZalo,
      removeError,
      CommonService,
      errors,
      errorMessage,
      showButtonConnect
    }
  }
}
</script>

<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
      }
    }
  }
}
</style>